module.exports = __webpack_public_path__ + "static/forecast/temperature/thaw-61521eb461a835d99a6063571102d798.svg";